'use client'

import {observer} from 'mobx-react'
import React from 'react'

import {CertificatesPageContent} from '@/src/core/domain/entities/catalog'
import {PageData} from '@/src/core/domain/entities/page/page-data'

import {CertificateProider} from '@/src/entities/product'

import {Certificates, CertificatesSchema} from '@/src/features/catalog'
import {FormProvider} from '@/src/shared/modules/form'

export const CatalogCertificatesScreen = observer((props: PageData<CertificatesPageContent>) => {
  return (
    <CertificateProider data={props.content}>
      <FormProvider schema={CertificatesSchema}>
        <Certificates {...props} />
      </FormProvider>
    </CertificateProider>
  )
})
